import { computed, inject, openBlock, createElementBlock, normalizeClass, Fragment, createElementVNode, renderSlot, createTextVNode, toDisplayString, createCommentVNode } from "vue";
import MENU_ITEM_TYPE from "./menu.es.js";
const _hoisted_1 = { class: "menu-group-title" };
const _hoisted_2 = { class: "menu-group-list" };
const _sfc_main = {
  __name: "MenuItem",
  props: {
    type: {
      type: String,
      default: MENU_ITEM_TYPE.ITEM,
      validator(type) {
        return Object.values(MENU_ITEM_TYPE).includes(type);
      }
    },
    id: {
      type: [Number, String],
      required: true
    },
    title: {
      type: String
    }
  },
  setup(__props) {
    const props = __props;
    const menuItemClasses = computed(() => [`menu-${props.type}`]);
    const isGroup = computed(() => props.type === MENU_ITEM_TYPE.GROUP);
    const isItem = computed(() => props.type === MENU_ITEM_TYPE.ITEM);
    const closeDropDown = inject("closeDropDown", () => {
    });
    const clickMenuItemHandler = () => {
      if (closeDropDown) {
        closeDropDown();
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(menuItemClasses.value)
      }, [
        isGroup.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createElementVNode("div", _hoisted_1, [
            renderSlot(_ctx.$slots, "title", {}, () => [
              createTextVNode(toDisplayString(props.title), 1)
            ])
          ]),
          createElementVNode("div", _hoisted_2, [
            renderSlot(_ctx.$slots, "default")
          ])
        ], 64)) : isItem.value ? renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
          createElementVNode("span", {
            class: "menu-item-title",
            onClick: clickMenuItemHandler
          }, toDisplayString(props.title), 1)
        ]) : createCommentVNode("", true)
      ], 2);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=MenuItem.vue.es.js.map
